import * as React from 'react';

type CheckmarkNewIconProps = React.SVGProps<SVGSVGElement> & {
  strokeWidth?: number;
};

export const CheckmarkNewIcon = ({
  strokeWidth,
  ...props
}: CheckmarkNewIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    {...props}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      stroke={strokeWidth !== undefined ? 'currentColor' : undefined}
      strokeWidth={strokeWidth}
      d="M21.736 3.526 9.106 20.88 2.37 14.13l1.26-1.26 5.264 5.25 11.37-15.644 1.472 1.05Z"
    />
  </svg>
);
